import React, { useState, useEffect, useCallback } from 'react';
import AddPoliciesModal from './AddPoliciesModal';
import '../styles/formStyles.css';

const API_URL = process.env.REACT_APP_API_BASE_URL;

function PoliciesList() {
  const [policies, setPolicies] = useState([]);
  const [addModalVisible, setAddModalVisible] = useState(false);
  const [expandedPolicyId, setExpandedPolicyId] = useState(null);
  const token = localStorage.getItem('token');

  const fetchPolicies = useCallback(async () => {
    try {
      const response = await fetch(`${API_URL}/policies`, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      });
      const data = await response.json();
      if (response.ok && Array.isArray(data)) {
        setPolicies(data);
      } else {
        setPolicies([]);
      }
    } catch (error) {
      setPolicies([]);
    }
  }, [token]);

  useEffect(() => {
    fetchPolicies();
  }, [fetchPolicies]);

  // Função para formatar data para o padrão DD-MM-AAAA
  const formatDate = (dateString) => {
    if (!dateString) return 'N/A';
    // Remove a parte da hora, se houver, para evitar problemas de fuso horário
    const dateOnlyString = dateString.split(' ')[0];
    // Adiciona 'T00:00:00' para garantir que a data seja interpretada no fuso horário local
    const date = new Date(`${dateOnlyString}T00:00:00`);
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Mês é base 0
    const year = date.getFullYear();
    return `${day}-${month}-${year}`;
  };

  const handleOpenAddModal = () => setAddModalVisible(true);
  const handleCloseAddModal = () => setAddModalVisible(false);

  // Após adicionar, recarrega a listagem da API
  const handleAddPolicy = () => {
    fetchPolicies();
    handleCloseAddModal();
  };

  // Componente para renderizar a célula de descrição com HTML e "Ver mais"
  const PolicyDescriptionCell = ({ policy }) => {
    const isExpanded = expandedPolicyId === policy.id;

    const toggleDescription = () => {
      setExpandedPolicyId(isExpanded ? null : policy.id);
    };

    const linkButtonStyle = {
      background: 'none',
      border: 'none',
      color: 'blue',
      cursor: 'pointer',
      padding: '5px 0',
      display: 'block',
    };

    return (
      <td style={{ width: '60%' }}>
        {isExpanded && (
          <button onClick={toggleDescription} style={linkButtonStyle}>
            ver menos
          </button>
        )}
        <div style={{ maxHeight: isExpanded ? 'none' : '125px', overflow: 'hidden', position: 'relative' }} dangerouslySetInnerHTML={{ __html: policy.textPolicy }} />
        {!isExpanded && (
          <button onClick={toggleDescription} style={linkButtonStyle}>
            ver mais
          </button>
        )}
      </td>
    );
  };

  return (
    <section className="dashboard-section">
      <h3>Políticas</h3>
      {policies.length > 0 ? (
        <table className="dashboard-table">
          <thead>
            <tr>
              <th className="hidden-column">ID</th>
              <th style={{ width: '60%' }}>Descrição</th>
              <th>Status</th>
              <th>Data de Criação</th>
            </tr>
          </thead>
          <tbody>
            {policies.map((policy, index) => (
              <tr key={policy.id} className={index % 2 === 0 ? 'even-row' : 'odd-row'}>
                <td className="hidden-column">{policy.id}</td>
                <PolicyDescriptionCell policy={policy} />
                <td>{policy.status === 1 ? 'Ativo' : 'Inativo'}</td>
                <td>{formatDate(policy.dataCadastro)}</td>
              </tr>
            ))}
          </tbody>
        </table>
      ) : (
        <p>Nenhuma política encontrada.</p>
      )}
      <div style={{ marginTop: '10px', textAlign: 'right' }}>
        <button onClick={handleOpenAddModal} title="Adicionar Política" className="button-style">
          +
        </button>
      </div>
      {addModalVisible && (
        <AddPoliciesModal
          visible={addModalVisible}
          onClose={handleCloseAddModal}
          onAdd={handleAddPolicy}
        />
      )}
    </section>
  );
}

export default PoliciesList;